import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ApiUsuarioService } from '../services/api-usuario.service';
import { PlatformService } from '../services/platform.service';

@Injectable({
    providedIn: 'root'
})
export class EmbeddedLoginGuard {

    private readonly _router = inject(Router);
    private readonly _apiUsuario = inject(ApiUsuarioService);

    canActivate(): boolean | UrlTree {
        if (PlatformService.isInIframe()) {
            this._apiUsuario.sendSessionExpired();
            return this._router.createUrlTree(['/loading']);
        }
        return true;
    }
}
